
// src/components/CategorySelector.js

import React from 'react';

function CategorySelector({ onChange, currentCategory, categories, categoryColors }) {
  return (
    <div style={{ marginBottom: '10px' }}>
      {categories.map((cat) => (
        <button
          key={cat}
          onClick={() => onChange(cat)}
          style={{
            backgroundColor: categoryColors[cat],
            color: 'white',
            border: currentCategory === cat ? '2px solid black' : 'none',
            marginRight: '5px',
            padding: '10px 15px',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          {cat}
        </button>
      ))}
    </div>
  );
}

export default CategorySelector;